import React from 'react'
import classNames from 'classnames'

import { TitleTextProps } from './TitleText.schema'

import Button from '@/button/Button'
import ButtonList from '@/button-list/ButtonList'
import Appear from '@/appear/Appear'
import Markdown from '@/markdown/Markdown'
import RevealText from '@/reveal-text/RevealText'

const TitleTextWrapper = (props: TitleTextProps & { children: React.ReactNode }): JSX.Element => {
    const className = classNames('title-text', props.className)

    if (props.disableAppear) {
        return (
            <div className={className}>
                {props.children}
            </div>
        )
    }

    return (
        <div className={className}>
            <Appear cascade delay={props.appearDelay}>
                {props.children}
            </Appear>
        </div>
    )
}

const TitleText = (props: TitleTextProps) => {
    const HeadingElement = props.headingElement ?? 'h1'
    const headingDisplay = props.headingDisplay ?? 'h2'
    const hasTitleAnimation = props.hasTitleAnimation ?? true

    return (
        <TitleTextWrapper {...props}>
            {props.title && (
                hasTitleAnimation ? (
                    <RevealText headingElement={HeadingElement} className={classNames('title-text__title', headingDisplay + '--display')} text={props.title} />
                ) : (
                    <HeadingElement className={classNames('title-text__title', headingDisplay + '--display')} dangerouslySetInnerHTML={{ __html: props.title.replace(/<(?!mark|\/mark)[^>]+>/ig, '') }}></HeadingElement>
                )
            )}
            {props.text && (
                props.hasMarkdown ? (
                    <Markdown className="text-large text">{props.text}</Markdown>
                ) : (
                    <p className="text-large">{props.text}</p>
                )
            )}
            {props.buttonList && <ButtonList {...props.buttonList} />}
            {props.button && !props.buttonList && <Button className="title-text__button" icon="arrow-right" {...props.button} />}
        </TitleTextWrapper>
    )
}

export default TitleText
